import { addEntity } from '@hozana/api/actions'

import { NOTIFICATION_TYPE } from 'modules/notification/constants'

import type { TNotification } from './types'

export const addNotification = <NT extends NOTIFICATION_TYPE>(notification: TNotification<NT>) =>
  addEntity('notification', notification.id, notification)
